
/* 
    @description  所有路由必须遵循路由接口规范
    @autor        shuxiaokai
    @create       2019-07-31 17:23"
    @interface
        Route {
            path: "a-d-create",   //路由地址
            name: "新增计划",      //路由名称
            meta: {
                title: "新增计划", //用于显示在tabs上面的标题
                bread: [
                    { to: "", title: "计划管理" }, //面包屑导航， to字符串不为空则可以跳转到相应位置
                    { to: "", title: "计划草稿" },
                    { to: "/v1/a/a-d-create", title: "新增计划" }
                ],
                developer: {
                    name: "cc" //开发者信息(推荐使用自己姓名的拼音)
                },
                keyword: [], //用于搜索时显示相关路由信息
                couldBeMenu: true, //这个路由是否能成为左侧菜单
                couldShowGoBackTip: true, //是否展示返回上级按钮
                couldCache: false, //页面是否允许被缓存,注意：页面可以被缓存，则无法存在多个tab
                couldBeMulti: false, //页面是否允许存在多个tab
                permission: {}, //权限保留字段，未来页面权限将在这里面存取
            },            
        }
*/
import Vue from "vue"
import Router from "vue-router"
import NProgress from "nprogress"
import "nprogress/nprogress.css"
//=====================================注册登陆页面====================================//
import login from "@/pages/login/login"
import layout from "@/pages/layout/index"
//=====================================业务模块====================================//
import a from "@/pages/model/a/a"
import b from "@/pages/model/b/b"
import c from "@/pages/model/c/c"
import cAdd from "@/pages/model/c/add/add"
import d from "@/pages/model/d/d"
import e from "@/pages/model/e/e"
import f from "@/pages/model/f/f"
import edit from "@/pages/model/a/edit/edit"
//=====================================测试界面====================================//
import test from "@/pages/test/test"


Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: "/",
            redirect: "/v1/a/a"
        },
        {
            path: "/login",
            component: login
        },
        {
            path: "/d",
            component: d,
        },
        {
            path: "/f",
            component: f,
        },
        {
            path: "/v1",
            name: "enlarge",
            component: layout,
            children: [
                {
                    path: "a/a",
                    component: a
                },
                {
                    path: "b/b",
                    component: b
                },
                {
                    path: "c/c",
                    component: c
                },
                {
                    path: "c/c/add",
                    component: cAdd
                },
                {
                    path: "a/edit",
                    component: edit
                },
                {
                    path: "test",
                    component: test
                },
                {
                    path: "e/e",
                    component: e
                },
            ]
        },

    ]
})


//=====================================开发模式提供数据配置选项====================================//
if (process.env.NODE_ENV === "development") {
    //router.addRoutes([])
}

router.beforeEach((to, from, next) => {
    NProgress.start()
    next()
})

router.afterEach((to, from) => {
    NProgress.done() // 页面顶部的加载条
})

export default router
